import instance from 'config/interceptor';

export const downloadDeliveryMIS = async (data, onDownloadProgress: any) => {
  try {
    return await instance.post(
      process.env.REACT_APP_URL + `/Delivery/DeliveryCreateMIS`,
      data,
      { responseType: 'arraybuffer', onDownloadProgress }
    );
  } catch (error) {
    return error;
  }
};
